import React from 'react';
import { screenshots } from '../data/media';
import './Screenshots.css';

// src/assets/screens klasoru bosken bu bolum hic render edilmez,
// yani sitede bos telefon cerceveleri gorunmez.
const Screenshots = () => {
  if (screenshots.length === 0) return null;

  return (
    <section className="screens">
      <div className="container">
        <div className="screens__head">
          <p className="eyebrow eyebrow--on-dark">Uygulamadan</p>
          <h2 className="section-title screens__title">Ekranlar</h2>
          <p className="section-lead section-lead--on-dark">
            Harita, sesli anlatım ve mekân detayları — uygulamanın gerçek ekranları.
          </p>
        </div>

        <div className="screens__strip">
          {screenshots.map((shot, index) => (
            <figure className="phone" key={shot.src}>
              <div className="phone__frame">
                <span className="phone__notch" />
                <img
                  src={shot.src}
                  alt={`Travel Istanbul uygulama ekranı ${index + 1}`}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Screenshots;
